import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';

const SectionBlock = ({ section, testId }) => (
  <div className="space-y-2 rounded-[18px] border border-white/10 bg-white/[0.03] p-4" data-testid={testId}>
    <p className="text-[10px] uppercase tracking-[0.18em] text-white/42" data-typography="label" data-testid={`${testId}-heading`}>{section.heading}</p>
    {section.body ? <p className="text-sm leading-6 text-white/78" data-testid={`${testId}-body`}>{section.body}</p> : null}
    {section.formula ? (
      <div className="rounded-2xl border border-white/8 bg-black/30 px-3 py-2 font-mono text-xs text-[#7CE8FF]" data-testid={`${testId}-formula`}>
        {section.formula}
      </div>
    ) : null}
    {section.breakdown?.length ? (
      <div className="grid gap-2 sm:grid-cols-2" data-testid={`${testId}-breakdown`}>
        {section.breakdown.map((item, index) => (
          <div key={`${item.label}-${index}`} className="rounded-2xl border border-white/8 bg-black/25 px-3 py-3" data-testid={`${testId}-breakdown-${index}`}>
            <p className="text-[10px] uppercase tracking-[0.16em] text-white/38" data-typography="label">{item.label}</p>
            <p className={`mt-1 text-sm font-semibold ${item.toneClass || 'text-white'}`} data-typography="metric">{item.value}</p>
            {item.note ? <p className="mt-1 text-[11px] text-white/48">{item.note}</p> : null}
          </div>
        ))}
      </div>
    ) : null}
    {section.note ? <p className="text-xs leading-5 text-white/52" data-testid={`${testId}-note`}>{section.note}</p> : null}
  </div>
);

export const OptionsAnalyticsMetricInfoDialog = ({ info, testId }) => {
  if (!info) return null;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex h-4 w-4 items-center justify-center rounded-full border border-white/12 text-[10px] text-white/55 transition-colors hover:border-white/25 hover:text-white"
          data-testid={`${testId}-trigger`}
        >
          i
        </button>
      </DialogTrigger>
      <DialogContent className="max-h-[82vh] w-[min(92vw,500px)] max-w-[500px] overflow-y-auto border border-white/12 bg-[#101117] p-0 text-white shadow-2xl" data-testid={`${testId}-content`}>
        <DialogHeader className="border-b border-white/10 px-5 py-5 text-left">
          <DialogTitle className="text-xl font-black tracking-tight text-white" data-typography="heading" data-testid={`${testId}-title`}>{info.title}</DialogTitle>
          {info.description ? <DialogDescription className="pt-2 text-sm leading-6 text-white/60" data-testid={`${testId}-description`}>{info.description}</DialogDescription> : null}
        </DialogHeader>

        <div className="space-y-3 px-5 py-5" data-testid={`${testId}-sections`}>
          {info.sections.map((section, index) => (
            <SectionBlock key={`${info.title}-${index}`} section={section} testId={`${testId}-section-${index}`} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OptionsAnalyticsMetricInfoDialog;